
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ChevronDown, ChevronUp } from "lucide-react";

const faqs = [
  {
    question: "What payment methods do you accept?",
    answer: "We accept credit/debit cards, UPI, net banking, and cash on delivery (COD) for orders above ₹500.",
  },
  {
    question: "How long does shipping take?",
    answer: "Standard shipping takes 3-5 business days. We offer free shipping on prepaid orders above ₹500. Express 24-hour delivery is available in Delhi, NCR for an additional charge.",
  },
  {
    question: "Can I return or exchange my order?",
    answer: "Yes, you can return or exchange items within 7 days of delivery. Items must be unused, unworn, and in original packaging with all tags attached.",
  },
  {
    question: "Do you offer gift wrapping?",
    answer: "Yes, we offer elegant gift wrapping services. You can select this option during checkout.",
  },
  {
    question: "Are your products authentic?",
    answer: "Yes, all our products are authentic and come with certificates of authenticity. We guarantee the quality and authenticity of every piece.",
  },
  {
    question: "What is your return policy?",
    answer: "We offer a 7-day return policy. Items must be in original condition with all tags and certificates. Customized items cannot be returned.",
  },
  {
    question: "How do I track my order?",
    answer: "Once your order is shipped, you'll receive a tracking number via email and SMS. You can track your order status in real-time using this number.",
  },
  {
    question: "Do you ship internationally?",
    answer: "Currently, we ship only within India. We're working on expanding our shipping to international locations soon.",
  },
];

export default function FAQPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow pt-24 pb-24">
        <div className="container mx-auto px-4 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold font-playfair mb-8 text-center">
              Frequently Asked Questions
            </h1>
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white rounded-lg border border-gray-200 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
                  >
                    <span className="font-semibold text-lg text-gray-900">{faq.question}</span>
                    {openIndex === index ? (
                      <ChevronUp className="w-5 h-5 text-gray-600 flex-shrink-0" />
                    ) : (
                      <ChevronDown className="w-5 h-5 text-gray-600 flex-shrink-0" />
                    )}
                  </button>
                  {openIndex === index && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      className="px-6 pb-6 text-gray-600"
                    >
                      {faq.answer}
                    </motion.div>
                  )}
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
}
